<template>
  <div :class="['app', state.status]">
    <nav>
      <!-- <router-link :to="{ name: 'dev' }">Dev playground</router-link>
      <br> -->
      <div class="logo">
        <router-link to="/home">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="231.64 156.6 708.66 227.76" style="enable-background:new 0 0 1190.55 841.89" xml:space="preserve">
                <path class="st0" d="M391.91 214.54h-19.08c-.24 0-.52-.02-.85-.02-4.78 0-21.36.95-33.99 13.03-6.3 6.02-13.81 17.05-13.81 35.37v74.29c0 1 .81 1.83 1.82 1.83h31.88c1 0 1.81-.83 1.81-1.83v-74.29c0-4.59.94-7.83 2.78-9.64 2.68-2.64 7.73-3.24 9.44-3.24h20.02c.47 0 .94-.18 1.28-.53.34-.33.53-.8.53-1.28v-31.88a1.84 1.84 0 0 0-1.83-1.81zM313.9 156.6h-34.41c-4.8 0-21.41.94-34.04 13.01-6.31 6.03-13.81 17.06-13.81 35.37V337.2c0 1 .82 1.83 1.81 1.83h31.88c1.01 0 1.83-.83 1.83-1.83v-82.93h37.7c1.01 0 1.82-.82 1.82-1.82v-31.88c0-1-.82-1.82-1.82-1.82h-37.7v-13.77c0-4.58.93-7.82 2.77-9.64 2.68-2.64 7.73-3.22 9.44-3.23l34.54.01a1.824 1.824 0 0 0 1.82-1.83v-31.87c-.01-.99-.82-1.82-1.83-1.82zM460.78 219.04c-33.52 0-60.79 27.26-60.79 60.79 0 33.52 27.26 60.8 60.79 60.8 8.84 0 17.33-1.86 25.29-5.53v2.12c0 1 .81 1.83 1.81 1.83h31.88c1.01 0 1.82-.83 1.82-1.83V277.8c0-.17-.03-.34-.07-.5-1.34-32.71-27.94-58.26-60.73-58.26zm0 35.5c13.95 0 25.29 11.34 25.29 25.28 0 13.95-11.35 25.27-25.29 25.27s-25.28-11.33-25.28-25.27 11.35-25.28 25.28-25.28zM764.66 219.69h-31.88c-1.02 0-1.82.81-1.82 1.81 0 19.68-12.7 35.95-28.67 37.26v-82.67c0-1-.81-1.82-1.82-1.82H668.6c-1 0-1.81.82-1.81 1.82v161.34c0 1.01.81 1.83 1.81 1.83h31.88c1.01 0 1.82-.82 1.82-1.83v-42.98h9.53c4.58 0 7.82.93 9.63 2.78 2.64 2.68 3.24 7.71 3.24 9.43l-.01 30.77c0 .49.2.95.53 1.29.35.35.81.54 1.29.54h31.87c1.01 0 1.82-.82 1.82-1.83v-29.84c.08-3.45-.18-21.4-12.98-34.81 12.43-13.76 19.26-31.89 19.26-51.28 0-1-.82-1.81-1.82-1.81zM592.93 217c-29.64 0-53.73 24.1-53.73 53.73v66.48c0 1 .82 1.83 1.81 1.83h31.89c1 0 1.81-.83 1.81-1.83v-66.48c0-10.05 8.17-18.22 18.23-18.22 10.04 0 18.21 8.18 18.21 18.22v66.48c0 1 .82 1.83 1.82 1.83h31.87c1.03 0 1.83-.83 1.83-1.83v-66.48c-.02-29.63-24.12-53.73-53.74-53.73zM813.47 174.27H781.6c-1.01 0-1.83.82-1.83 1.82v161.34c0 1.01.82 1.83 1.83 1.83h31.87c1 0 1.82-.82 1.82-1.83V176.09c0-1-.82-1.82-1.82-1.82zM938.47 217.44H906.6c-1.01 0-1.82.81-1.82 1.82v67.39c0 10.05-8.17 18.21-18.22 18.21-10.05 0-18.21-8.17-18.21-18.21v-67.39c0-1.01-.82-1.82-1.82-1.82h-31.87c-1.01 0-1.83.81-1.83 1.82v67.39c0 22.94 14.41 43.15 35.98 50.71v45.17c0 1 .81 1.83 1.82 1.83h31.88c1 0 1.81-.83 1.81-1.83v-45.17c21.58-7.56 35.98-27.77 35.98-50.71v-67.39c0-1.01-.83-1.82-1.83-1.82z"/>
            </svg>
        </router-link>
      </div>
      <div class="main-menu">
        <h3>{{ state.username }}</h3>
        {{ state.scope }}
        <router-link to="/" class="button" @click.prevent="logout" v-if="state.loggedIn">Logout</router-link>
        <router-link class="admin-button button" :to="{ name: 'admin' }" v-if="state.adminAccess">Admin</router-link>
      </div>
    </nav>
    <router-view/>
  </div>
</template>

<script>
import useState from '@/use/useState'
import useLogout from '@/use/useLogout'

export default {
  setup() {
    const state = useState()

    // Logout function
    const logout = () => {
      useLogout()
      state.value.loggedIn = false
      state.value.username = ''
    }

    return { state, logout }

  },
}
</script>


